export default class OrderItemsDTO {
  constructor(packageId, isYearly, featureId, quantity) {
    this.packageId = packageId;
    this.isYearly = isYearly;
    this.featureId = featureId;
    this.quantity = quantity;
  }
}
